import { externalNetworkClient } from '@terra/shared-rest-clients-external-network';
import type { ExternalNetworkContract } from '@terra/shared-contracts-external-network';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const externalNetworkAssetFilterOptionsApi = {
  getSurfaceAssetFilterOptions: (surfaceId: string) =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.getAssetFilterOptions>(
      {
        endpointFn: (headers) =>
          externalNetworkClient.getAssetFilterOptions({
            params: { surfaceId },
            ...withOrchestratorClient(headers),
          }),
      },
    ),
};
